import React from "react";
import JVHero from "../components/JointVenture/JVHero";
import JVHowItWorks from "../components/JointVenture/JVHowItWorks";
import JVComparison from "../components/JointVenture/JVComparison";
import JVWhyPartner from "../components/JointVenture/JVWhyPartner";
import JVAreas from "../components/JointVenture/JVAreas";
import JVFeaturedProperties from "../components/JointVenture/JVFeaturedProperties";
import JVFAQ from "../components/JointVenture/JVFAQ";
import JVCallToAction from "../components/JointVenture/JVCallToAction";

export const Site = () => {
  return (
    <div className="App">
      <JVHero />
      <JVHowItWorks />
      <JVComparison />
      <JVWhyPartner />
      <JVAreas />
      <JVFeaturedProperties />
      <JVFAQ />
      <JVCallToAction />
    </div>
  );
};
export default Site;
